import HubspotForm from 'react-hubspot-form';
import { useEffect, useState } from 'react';
import { preventFormSubmissionForInternalUsers } from '../helpers/jsHelper';
import Loader from '../components/Loader/Loader';
import InfoDialogUI from '../components/InfoDialog/InfoDialogUI';
import { useUserContext } from '../contexts/UserContext';

export const HubspotFormModal = ({
  title = '',
  open = false,
  onClose = null,
  portalId = null,
  formId = null,
}) => {
  const [loading, setLoading] = useState(true);
  const { currentUser } = useUserContext();

  useEffect(() => {
    if (loading) return;
    const timerId = setTimeout(() => preventFormSubmissionForInternalUsers({
      formTitle: title,
      loggedInUserName: currentUser?.user?.name,
      loggedInUserEmail: currentUser?.user?.email,
    }), 1000);
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [currentUser, loading, open]);

  if (!portalId || !formId || !open) return null;

  return (
    <InfoDialogUI title={title} show onClose={onClose}>
      <div style={{ minHeight: 44, position: 'relative' }}>
        <HubspotForm
          region="na1"
          version="V2_PRERELEASE"
          portalId={portalId}
          formId={formId}
          loading={<Loader loading position="absolute" />}
          onReady={() => setLoading(false)}
        />
      </div>
    </InfoDialogUI>
  );
};
